"use client";
import CaseStudy from "@/components/CaseStudy";

export default function CaseStudyPage() {
  return <CaseStudy />;
}
